import { Empresa } from './empresa';

export class LogPix  {
    public Id: number;    
    public Empresa: Empresa;
    public NumSolicitacao: number;    
    public Status: string; 
    public Obs: string; 
    public PrimeiraCartela: string; 
    public SegundaCartela: string; 
}


// WEBPACK FOOTER //
// ./src/entities/logPix.ts